<template>
  <div>
    <el-alert type="warning" title="使用TinyPNG对Jpeg、Jpg图片进行压缩，原理是使用canvas，无法使用WebWorker" :closable="false">
    </el-alert>
    <div style="display: flex; margin-top: 10px;">
      <el-upload class="upload-demo" drag :multiple="false" :http-request="uploadImg" :show-file-list="false"
        action="/">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
      <div style="display: flex;" v-loading="compressing">
        <el-image style="margin-left: 40px; width: 180px; height: 180px; flex-shrink:0 ; margin-right: 10px"
          :src="imgUrl" :preview-src-list="[imgUrl]" fit="contain">
        </el-image>
        <el-descriptions title="压缩信息" :column="1" v-if="compressResult.compressedSize">
          <el-descriptions-item label="压缩前">{{ getSizeTrans(compressResult.originalSize)
            }}</el-descriptions-item>
          <el-descriptions-item label="压缩后">{{ getSizeTrans(compressResult.compressedSize)
            }}</el-descriptions-item>
          <el-descriptions-item label="压缩率">{{ compressResult.rateString }}</el-descriptions-item>
          <el-descriptions-item label="减少">
            <el-tag size="small" type="success">
              -{{ ((1 - compressResult.rate) * 100).toFixed(2) + '%' }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

  </div>
</template>
<script>
import TinyPNG from 'tinypng-lib'

import { getSizeTrans } from '../utils/index.js';
export default {
  name: 'Jpeg',
  props: {
    quality: {
      type: Number,
      default: 85
    },
  },
  data() {
    return {
      imgUrl: '',
      compressResult: {},
      compressing: false,
    }
  },

  methods: {
    getSizeTrans,
    async uploadImg(e) {

      this.compressing = true;
      try {
        const result = await TinyPNG.compressJpegImage(e.file, {
          quality: this.quality,
        })
        console.log("compress result: ", result)
        const url = URL.createObjectURL(result.blob);
        this.imgUrl = url;
        this.compressResult = result;
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.compressing = false;
      }
    }
  },
  beforeDestroy() {
    // Terminate the worker when the component is destroyed
    if (this.worker) {
      this.worker.terminate();
    }
  }
}
</script>
